import { Dialog, DialogContent } from "@material-ui/core";
import React, { useEffect, useContext, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as callActions from "../../actions/callActions";
import * as requestActions from "../../actions/requestActions";
import RoomContext from "../../context/RoomContext";
import { intl } from "../../intl";
import {
  startCallRingtone,
  stopCallRingtone,
} from "../../helpers/callRingtone";
import InComingOutGoingCall from "../Management/Messaging/components/InComingOutGoingCall";

const CallView = () => {
  const dispatch = useDispatch();

  const [second, setSecond] = useState(0);
  const [milisecond, setMilisecond] = useState(0);

  const incomingCall = useSelector((state) => state.call.incomingCall);
  const currentCall = useSelector((state) => state.call.currentCall);
  const outgoingCall = useSelector((state) => state.call.outgoingCall);
  const room = useSelector((state) => state.room);

  const { roomClient } = useContext(RoomContext);

  useEffect(() => {
    if (incomingCall) {
      startCallRingtone();

      const options = {
        body: intl.formatMessage({
          id: `messaging.inComing`,
          defaultMessage: "Incoming Call",
        }),
        image: "",
      };
      const notification = new Notification("Alliance Wunity", options);
      notification.onclick = function (event) {
        event.preventDefault();
        window.focus();
      };

      return () => {
        stopCallRingtone();
      };
    }

    stopCallRingtone();
    resetTimer();
    return undefined;
  }, [incomingCall]);

  useEffect(() => {
    if (currentCall || outgoingCall) {
      stopCallRingtone();
    }
  }, [currentCall, outgoingCall]);

  const handleAnswerCall = () => {
    stopCallRingtone();
    dispatch(callActions.setIncomingCall(undefined));
    dispatch(
      callActions.answerCall(
        incomingCall.payload.group.id,
        incomingCall.payload.roomId,
        incomingCall.fromId,
        incomingCall.payload.video
      )
    );
  };

  const handleRejectCall = () => {
    stopCallRingtone();
    dispatch(callActions.setIncomingCall(undefined));
    dispatch(
      callActions.rejectCall(
        incomingCall.payload.group.id,
        incomingCall.payload.roomId,
        incomingCall.payload.video
      )
    );
  };

  const handleEndCall = () => {
    stopCallRingtone();
    dispatch(callActions.endCall(outgoingCall.group.id, outgoingCall.roomId));
    dispatch(callActions.setOutgoingCall(undefined));
  };

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  const resetTimer = () => {
    setSecond(0);
    setMilisecond(0);
  };

  const timer = () => {
    setMilisecond(milisecond + 10);
    if (milisecond === 1000) {
      setMilisecond(0);
      setSecond(second + 1);
    }
  };
  useInterval(() => {
    if (outgoingCall || incomingCall) timer();
  }, 10);

  useEffect(() => {
    if (second >= 30 && currentCall === undefined) {
      resetTimer();
      stopCallRingtone();
      dispatch(callActions.setIncomingCall(undefined));
      dispatch(callActions.setOutgoingCall(undefined));
      if (outgoingCall) {
        dispatch(
          callActions.markNoAnswerCall(
            outgoingCall.group.id,
            outgoingCall.roomId,
            outgoingCall.video
          )
        );
        dispatch(
          requestActions.notify({
            text: intl.formatMessage({
              id: "messaging.userNotAnswering",
              defaultMessage: "User is not answering.",
            }),
          })
        );
      }
    }
  }, [second]);

  useEffect(() => {
    if (!outgoingCall) {
      resetTimer();
    }
  }, [outgoingCall]);

  useEffect(() => {
    if (currentCall) {
      stopCallRingtone();
      roomClient.join({
        roomId: currentCall.roomId,
        roomName: "",
        joinAudio: true,
        joinVideo: currentCall.video,
        call: true,
      });
      resetTimer();
    }
  }, [currentCall]);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };
  const prevRoomState = usePrevious(room?.spotlights);
  useEffect(() => {
    if (
      currentCall?.group?.type === "individual" &&
      prevRoomState?.length === 1 &&
      room?.spotlights?.length === 0
    ) {
      dispatch(callActions.endCall(currentCall.group.id, currentCall.roomId));
      dispatch(callActions.setCurrentCall(undefined));
    }
  }, [currentCall, room]);

  return (
    <div>
      {incomingCall && (
        <Dialog open={true}>
          <DialogContent style={{ padding: 0 }}>
            <InComingOutGoingCall
              data={incomingCall}
              type={"inComing"}
              onReject={handleRejectCall}
              onAnswer={handleAnswerCall}
              onEnd={handleEndCall}
            />
          </DialogContent>
        </Dialog>
      )}

      {outgoingCall && (
        <Dialog open={true}>
          <DialogContent style={{ padding: 0 }}>
            <InComingOutGoingCall
              data={outgoingCall}
              type={"outGoing"}
              onReject={() => {}}
              onAnswer={() => {}}
              onEnd={handleEndCall}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CallView;
